module.exports = __webpack_public_path__ + "media/images/novum-logo-dark-79660d7cebb24eaf2379578dc702e548.png";